import * as amplify from "../../util/amplify.ts";
import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import * as forms from "../../util/forms.js";
import ApiServer from "../../ApiServer.js";
import * as i18n from "../../i18n.ts";
import {getCache} from "../../server/objects/BudgetBeans.js";
import MAIN_MODAL from "../../budget/modal_categories.mustache";
import MAIN_MODAL_HIDDEN from "../../budget/modal_categories_hidden.mustache";
import TPL_ITEM from "../../budget/modal_categories_item.mustache";
import { registerDragStart } from "../../lib/FileUtils.ts";

const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();


Html.register({
  budgetcategoryuiadd:function(){
    var 
        theModal = this.parents('.modal'),
        budgetTransactionType = theModal.find('[name=budgetTransactionType]').val(),
        goodGroup = theModal.find('[data-transaction-type='+budgetTransactionType+']'),
        catNode = Html.setHtmlAtEnd(goodGroup,TPL_ITEM,{emoji:'💰',rights:{canUpdate:true,canDelete:true}})
      catNode.find('input[name=name]').focus()  
  },
  budgetcategoryuihidden:function(){
    var 
        theModal = this.parents('.modal'),
        openType = theModal.find('[name=budgetTransactionType]').val(),
        budgetTransactionType,
        hiddenCategories = budgetCategoryCache.hidden(),
        theModalHidden;
        
    
    modal.closeModal()    
    theModalHidden = modal.openModal(MAIN_MODAL_HIDDEN,{
          budgetTransactionType:openType,
          isEmpty:hiddenCategories.length===0,
          EXPENSE:hiddenCategories.filter(cat=>cat.budgetTransactionType==='EXPENSE'),
          REVENUE:hiddenCategories.filter(cat=>cat.budgetTransactionType==='REVENUE')
        });
    budgetTransactionType = theModalHidden.find('[name=budgetTransactionType]')
    theModalHidden.find("flexrow>icon").on('click',function(){
      var 
        metaIdNode = $(this).metaIdNode(),
        metaId = metaIdNode.metaId(),
        category = budgetCategoryCache.get(metaId);
        
      category.hidden = false;
      ApiServer.budgetcategoryput(category,function(){
        var categoryCount = theModalHidden.find('[data-fw-meta-id]:visible').length
        if(categoryCount>1){
          metaIdNode.fadeOut();
        }else{
          metaIdNode.remove();
          theModalHidden.find('.empty').show()
        }
      })
      budgetCategoryCache.refresh()
    })
    theModalHidden.onClose=function(){
      Html.trigger("budgetcategorymanage")
    }
    function updateUI(){
      theModalHidden.find('[data-transaction-type]').each((idx,obj)=>{
        obj = $(obj)
        obj.toggle(obj.attr('data-transaction-type')===budgetTransactionType.val())
      })
      console.log(theModalHidden.find('[data-transaction-type="'+budgetTransactionType.val()+'"] [data-fw-meta-id]'))
      theModalHidden.find('.empty').toggle(theModalHidden.find('[data-transaction-type="'+budgetTransactionType.val()+'"] [data-fw-meta-id]').length===0)
    }
    updateUI()
    theModalHidden.delegate('input','change',updateUI)
  },
  
  budgetcategorymanage:function(type){
    let theModal,modified=false;

    theModal = modal.openModal(MAIN_MODAL,{
      budgetTransactionType:type==='REVENUE'?'REVENUE':'EXPENSE',
      EXPENSE:budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType==='EXPENSE'),
      REVENUE:budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType==='REVENUE')
    })
    var 
      budgetTransactionType = theModal.find('[name=budgetTransactionType]');
      
    function updateUI(){
      var currentType = budgetTransactionType.val();
      theModal.find('[data-transaction-type]').each((idx,obj)=>{
        obj = $(obj)
        obj.toggle(obj.attr('data-transaction-type')===currentType)
      })
    }
    updateUI();
    theModal.find('input').on('keypress',function(ev){
      if(ev.keyCode===13 || ev.keyCode===10){
        ev.preventDefault();
        $(this).blur()
      }
    })
    theModal.onClose=function(){
      if(modified){
        amplify.publish('budgetNeedRefresh')
      }
    }
    theModal.delegate('input','change',function(){
      if(this.name!=='emoji' && this.name!=='name') {
        updateUI();
        return; 
      }
      var 
        catnode = $(this).parents('flexrow').first(),
        name = catnode.find('[name=name]').val(),
        emoji = catnode.find('[name=emoji]').val();
      if(!name){
        forms.markInvalid(catnode,i18n.get('budget.categoryerrors.noname')).find('input').focus()
        return;
      }  
      ApiServer.budgetcategoryput({metaId:catnode.metaId(),emoji:emoji,name:name,budgetTransactionType:budgetTransactionType.val()},function(newCat){
        modified = true;
        catnode = Html.replaceWith(catnode,TPL_ITEM,newCat)
        forms.markValid(catnode)
      },function(err){
        if(err.code==='63'){
          forms.markInvalid(catnode,i18n.get('budget.categoryerrors.63')).find('input').focus()
        }else{
          throw err;
        }
      })
    })
    theModal.delegate('flexrow>icon[data-type="delete"]','click',function(){
      var 
        catnode = $(this).parents('flexrow').first(),
        metaId = catnode.metaId();
      forms.markValid(catnode)
      if(!metaId){
        catnode.fadeOut();
      } else{
        ApiServer.budgetcategoryput({metaId:metaId,hidden:true},function(){
          modified = true;
          catnode.fadeOut();
        })
        budgetCategoryCache.refresh()
      }
    })
  }
})

registerDragStart(".budgetcategorylist>*",async function(ev,dropPromiseBuilder){
  var  
    movingNode = $(this),
    potentialDrop = document.querySelectorAll('.budgetcategorylist>*'),
    dropEvent = await dropPromiseBuilder(this,potentialDrop),
    dropNode = $(dropEvent.target).metaIdNode();

  var nodeBefore = null;
  if(dropNode.offset().top + dropNode.height()/2>dropEvent.clientY){
    nodeBefore = dropNode.prev();
    movingNode.detach().insertBefore(dropNode)
  }else{
    nodeBefore = dropNode;
    movingNode.detach().insertAfter(dropNode)
  }
  ApiServer.budgetcategoryput({metaId:movingNode.metaId(),prevId:nodeBefore.metaId()||"$empty"},function(){})
  amplify.publish('budgetNeedRefresh');

})
